import {
  BulkWalletEntryMode,
  OrderFulfillmentStatus,
  OrderSource,
  OrderStatus,
  OrderType,
  PaymentMethod,
  PaymentTradeStatus,
  ProductCode,
  UserLevelType,
  WalletRechargeStatus,
  WalletRechargeType,
} from "~/common/constants"

// Staff 内部使用的订单 / 权益文案；面向用户的文案见 common/billing/labels.ts

export const bulkEntryModeLabel: Record<BulkWalletEntryMode, string> = {
  [BulkWalletEntryMode.quantity]: "按积点数量",
  [BulkWalletEntryMode.amount]: "按充值金额",
}

export const levelLabel: Record<UserLevelType, string> = {
  [UserLevelType.free]: "FREE",
  [UserLevelType.pro]: "PRO",
}

export const levelTagColor: Record<UserLevelType, string> = {
  [UserLevelType.free]: "green",
  [UserLevelType.pro]: "blue",
}

export const orderTypeLabel: Record<OrderType, string> = {
  [OrderType.levelPackage]: "专业版订单",
  [OrderType.walletPackage]: "积点订单",
  [OrderType.bulkWalletPackage]: "大客户积点",
}

export const productCodeLabel: Record<ProductCode, string> = {
  [ProductCode.proMonthlyV1]: "专业版月度套餐",
  [ProductCode.proMonthlyGiftV1]: "Staff赠送专业版月度套餐",
  [ProductCode.walletProV1]: "专业版积点包",
  [ProductCode.walletFreeV1]: "免费版积点包",
  [ProductCode.bulkWalletV1]: "大客户积点",
}

export const orderStatusLabel: Record<OrderStatus, string> = {
  [OrderStatus.init]: "初始化",
  [OrderStatus.waitPay]: "等待支付",
  [OrderStatus.cancelled]: "已取消",
  [OrderStatus.closed]: "已关闭",
  [OrderStatus.succeeded]: "支付成功",
}

export const fulfillmentStatusLabel: Record<OrderFulfillmentStatus, string> = {
  [OrderFulfillmentStatus.init]: "尚未履约",
  [OrderFulfillmentStatus.scheduled]: "待生效",
  [OrderFulfillmentStatus.fulfilling]: "履约中",
  [OrderFulfillmentStatus.completed]: "已完成",
  [OrderFulfillmentStatus.cancelled]: "已取消",
}

export const orderSourceLabel: Record<OrderSource, string> = {
  [OrderSource.staffManual]: "Staff人工录入",
  [OrderSource.onlinePurchase]: "在线支付",
  [OrderSource.staffGift]: "Staff赠送",
}

export const paymentMethodLabel: Record<PaymentMethod, string> = {
  [PaymentMethod.wechat]: "微信支付",
  [PaymentMethod.alipay]: "支付宝支付",
  [PaymentMethod.staffGift]: "Staff赠送",
}

export const paymentStatusLabel: Record<PaymentTradeStatus, string> = {
  [PaymentTradeStatus.waitPay]: "等待支付",
  [PaymentTradeStatus.paid]: "支付成功",
  [PaymentTradeStatus.closed]: "已关闭",
}

export const rechargeTypeLabel: Record<WalletRechargeType, string> = {
  [WalletRechargeType.registrationGift]: "首登赠送",
  [WalletRechargeType.staff]: "Staff手动赠送",
  [WalletRechargeType.levelInclude]: "专业版月度积点",
  [WalletRechargeType.walletPackage]: "积点充值",
}

export const rechargeStatusLabel: Record<WalletRechargeStatus, string> = {
  [WalletRechargeStatus.scheduled]: "待生效",
  [WalletRechargeStatus.active]: "有效",
  [WalletRechargeStatus.exhausted]: "已用尽",
  [WalletRechargeStatus.expired]: "已过期",
}

export const giftTypeLabel: Record<API.Staff.StaffGiftType, string> = {
  WALLET_POINTS: "赠送积点",
  LEVEL_PACKAGE: "赠送专业版",
  ACTIVITY_GIFT: "活动权益赠送",
}

export const giftTypeColor: Record<API.Staff.StaffGiftType, string> = {
  WALLET_POINTS: "blue",
  LEVEL_PACKAGE: "purple",
  ACTIVITY_GIFT: "cyan",
}

export const giftStatusLabel: Record<API.Staff.StaffGiftStatus, string> = {
  GRANTED: "已赠送",
  REVOKED: "已撤销",
}

export const giftStatusColor: Record<API.Staff.StaffGiftStatus, string> = {
  GRANTED: "green",
  REVOKED: "default",
}
